import React from "react";
import { QeddyAssistant as SharedQeddyAssistant, type QeddyAssistantApi } from "../../../../../../shared/frontend/help/QeddyAssistant";
import { ApiError } from "../api/client";
import { useAuth } from "../auth/useAuth";
import { useI18n } from "../i18n/useI18n";
import { HTTP_SERVER_ERROR_MIN } from "../api/httpStatusRanges";

type QeddyAssistantProps = { onOpen?: () => void; onVisibilityChange?: (visible: boolean) => void; children?: React.ReactNode };

export function QeddyAssistant(props: QeddyAssistantProps) {
  const auth = useAuth();
  const { text } = useI18n();
  const api = React.useMemo<QeddyAssistantApi>(() => ({
    get: path => auth.api.get(path, { suppressGlobalErrorToast: true }),
    post: (path, body) => auth.api.post(path, body, { suppressGlobalErrorToast: true }),
  }), [auth.api]);
  return <SharedQeddyAssistant {...props} api={api} endpoint="/api/v1/help/qeddy" enabled={Boolean(auth.info)}
    scopeKey={JSON.stringify([auth.info?.tenantId, auth.info?.accountId, auth.info?.role, auth.info?.permissions, auth.info?.capabilities, auth.info?.studioAccessScope, auth.info?.allowedStudioIdsCsv, auth.info?.staffHrEnabled, auth.info?.staffTimeTrackingEnabled])} language={(auth.info?.language || "de").startsWith("en") ? "en" : "de"}
    productName="m1member" translate={text}
    errorMessage={error => error instanceof ApiError && error.status && error.status < HTTP_SERVER_ERROR_MIN ? error.message : text("Qeddy unavailable")} />;
}
